import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiClient } from './api-client.service';
import { VersionInfoDto } from '../../models/dto/version-info.dto';
import { StorageStatusDto } from '../../models/dto/storage-status.dto';

@Injectable({ providedIn: 'root' })
export class ApiEnvironmentService {
    private api = inject(ApiClient);

    getCustomerCode(): Observable<string> {
        return this.api.get<string>('/environment/customer-code', { responseType: 'text' });
    }

    getVersion(): Observable<VersionInfoDto> {
        return this.api.get<VersionInfoDto>('/environment/version', { spinner: false, toastErrors: false });
    }

    getStorageStatus(): Observable<StorageStatusDto> {
        return this.api.get<StorageStatusDto>('/environment/storage-status', { spinner: false, toastErrors: false }).pipe(map((r) => new StorageStatusDto(r)));
    }
}
